import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import { Skeleton } from './Card';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Componente de rota protegida - redireciona para login se não autenticado
 */
export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  console.log('🛡️ PROTECTEDROUTE: Estado atual:', {
    isLoading,
    hasUser: !!user,
    userEmail: user?.email,
    userRole: user?.role,
    currentPath: location.pathname
  });

  // Aguardar verificação de autenticação
  if (isLoading) {
    console.log('⏳ PROTECTEDROUTE: Aguardando verificação de autenticação...');
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="bg-white rounded-xl shadow-card p-8 w-96">
          <div className="flex items-center justify-center mb-6">
            <div className="w-12 h-12 bg-gradient-to-r from-emerald-600 to-emerald-700 rounded-xl flex items-center justify-center">
              <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
            </div>
          </div>
          <div className="text-center space-y-3">
            <Skeleton className="h-4 w-3/4 mx-auto" />
            <Skeleton className="h-3 w-1/2 mx-auto" />
          </div>
        </div>
      </div>
    );
  }

  // Se não autenticado, redirecionar para login preservando a rota tentada
  if (!user) {
    console.log('🚫 PROTECTEDROUTE: Usuário não autenticado, redirecionando para login');
    return (
      <Navigate 
        to="/login" 
        state={{ from: location.pathname }} 
        replace 
      />
    );
  }

  console.log('✅ PROTECTEDROUTE: Usuário autenticado, renderizando children');
  return <>{children}</>;
};